import React from 'react';
import { TransLink, TransAnchor } from '../Common/Translations';
import { compose, withProps } from 'recompose';

const removeAsterisk = (path) => {
  return path.replace(/\*/g, '');
};

const concatPath = (currentPath, path) => {
  const separator = (currentPath.length > 1) ? '/' : '';

  return `${currentPath}${separator}${removeAsterisk(path)}`;
};

const capitalizeFirstLetter = (string) => {
  return `${string.charAt(0).toUpperCase()}${string.slice(1).toLowerCase()}`;
};

const getPathFromUrl = (url) => {
  return url.split(/[?#]/)[0];
};

const getProductPagePaths = (props) => {
  if (props.editor.productPageHref) {
    const leadingPath = `${window.location.protocol}//${window.location.hostname}/`;
    const truncatedUrl = props.editor.productPageHref.replace(`${leadingPath}`, '');
    return getPathFromUrl(truncatedUrl).split('/');
  }
};

const getProductPageCrumbs = (props) => {
  if (props.editor && typeof props.editor.productPagePath !== 'undefined') {
    const paths = getProductPagePaths(props);
    const productPageCrumbs = paths.map((path) => {
      const textReplacements = [];
      const faberCastell = { text: 'faber castell', replacement: 'faber-castell' };
      textReplacements.push(faberCastell);

      var labelName = path.replace(/-/g, ' ');
      textReplacements.map((textReplacement) => {
        labelName = labelName.replace(textReplacement.text, textReplacement.replacement);
      });

      return ({ label: capitalizeFirstLetter(labelName), path });
    });

    productPageCrumbs.unshift({ label: 'Home', path: '/' });

    if (productPageCrumbs) {
      return productPageCrumbs;
    }
  }
};

const renderBreadCrumbs = (paths) => {
  return (props) => {
    let path = '';
    let breadcrumbs = '';
    let langCode = props.editor ? props.editor.langCode : '';
    if (paths) {
      breadcrumbs = paths.map((route, index) => {
        const isLastBreadcrumb = index === paths.length - 1;
        let { label } = route;
        label = label.trim().toLowerCase() == langCode ? '' : label;
        const routePath = route.path === "/:id" ? "/" : route.path;
        if (label) {
          const breadcrumb = <li key={label} className={`breadcrumb-item ${isLastBreadcrumb ? 'breadcrumb-item-last' : ''}`}>
            {
              props.isPrintBoxBreadCrumb
                ? routePath
                  && <TransAnchor url={path = concatPath(path, routePath)} name={label} />
                : routePath
                  && (
                    routePath === '/'
                      ? <a href={path = '/'}>{label}</a>
                      : <TransLink url={path = concatPath(path, routePath)} name={label} />
                  )
            }
            {!routePath && label}

          </li>;

          return breadcrumb;
        }
      });
    }
    return breadcrumbs;
  };
};

const generatePromotionsBreadCrumbs = (routes) => {
  let paths = filterEmptyRoutes(routes);
  let breadcrumbs = '';

  if (paths) {
    breadcrumbs = paths.map((route, index) => {
      const isLastBreadcrumb = index === paths.length - 1;
      let label = route.label;
      let path = '';
      const routePath = route.path === "/:id" ? "/" : route.path;
      path = concatPath(path, routePath);

      if(path !=='/' && path !== 'promotions') {
        path = `/promotions/${route.path}`;
      }

      return <li key={label} className={`breadcrumb-item ${isLastBreadcrumb ? 'breadcrumb-item-last' : ''}`}>
        {
          routePath === '/'
            ? <a href='/'>{label}</a>
            : <TransLink url={path} routePath={route.path} name={label} isPromoPage={true}/>
        }
      </li>;
    })
  }

  return breadcrumbs;
};

const filterEmptyRoutes = (routes) => {
  const filteredRoutes = routes && routes.filter((obj) => {
    if (obj.label && obj.label !== 'undefined') {
      return obj;
    }
  });
  return filteredRoutes;
};

const generateBreadCrumbs = (func) => {
  return (props) => {
    let paths = filterEmptyRoutes(props.routes);
    if (func instanceof Function) {
      paths = func(props);
    }
    return renderBreadCrumbs(paths)(props);
  };
};

const Container = (props) => {
  return <div> {generateBreadCrumbs()(props)} </div>;
};

const ProductPageContainer = (props) => {
  return <div> {generateBreadCrumbs(getProductPageCrumbs)(props)}</div>;
};

const ProductRecommendationContainer = (props) => {
  const filteredRoutes = filterEmptyRoutes(props.routes);

  return (
    <div>
      {renderBreadCrumbs(filteredRoutes)(props)}
    </div>
  );
};

export const PromotionsPageBreadcrumb = ({ routes }) => {
  return <div className="container px-0">
    <ol className="breadcrumb mb-0 white">{generatePromotionsBreadCrumbs(routes)}</ol>
  </div>;
};

const ConfigurableProductPageContainer = (props) => {
  const filteredRoutes = filterEmptyRoutes(props.routes);

  filteredRoutes.push({
    label: props.name,
    path: props.path,
  });

  return (
    <div>
      {renderBreadCrumbs(filteredRoutes)(props)}
    </div>
  );
};

const BreadCrumbs = (WrappedComp) => {
  return (props) => {
    return (
      <div className="container px-0">
        <ol className="breadcrumb mb-0 white"><WrappedComp {...props} /></ol>
        {props.children}
      </div>
    );
  };
};

const enhanced = compose(
  withProps({
    isPrintBoxBreadCrumb: true,
  }),
);

export default BreadCrumbs(Container);
export const ProductPageBreadCrumb = BreadCrumbs(enhanced(ProductPageContainer));
export const ConfigurableProductPageBreadCrumb = BreadCrumbs(ConfigurableProductPageContainer);
export const ProductRecommendationBreadCrumb = BreadCrumbs(ProductRecommendationContainer);



// WEBPACK FOOTER //
// ./src/Common/BreadCrumb.js